import React from 'react';
import { GiGraduateCap } from 'react-icons/gi';
import ExperienceContent from './ExperienceContent';


const Experience = () => {
  const experiences = [{
    title: 'Software Developer',
    company: 'Mild Technology',
    date: 'February 2023 - Present',
    description: 'Mild Technology established in 2022, specializes in software, Mobile application, and website development, as well as being a full-service technology solutions provider that is skilled in all phases of Social media application, etc.'
  }]
    return (
<div className="qualification">
            {/* qualification title */}
          <div className="titles flex items-center ">
            <div className="icon mr-3">
              <GiGraduateCap color="#C147E9" size={60} />
            </div>

            <h2 className="text-3xl font-bold"> Working Experience</h2>
          </div>


          {/* qualification conotent */}

         <div className='qqt mt-6'>
       {
        experiences.map((experience, index) =>  <ExperienceContent
        key={index}
        experience={experience}
        />)
        
       }
           
            
        
        
        
         </div>



        </div>
    );
};

export default Experience;